import { lazy } from 'react';

import AuthGuard from 'utils/route-guard/AuthGuard';
import MainLayout from 'layout/MainLayout';
import Loadable from 'ui-component/Loadable';

const ListaOrdenesProduccionView = Loadable(lazy(() => import('views/user/ProduccionView/ListaOrdenesProduccionView')));
const OrdenProduccionFormView = Loadable(lazy(() => import('views/user/ProduccionView/OrdenProduccionFormView')));
const RecetasProduccionView = Loadable(lazy(() => import('views/user/ProduccionView/RecetasProduccionView')));

const ProduccionRoutes = {
    path: '/',
    element: (
        <AuthGuard>
            <MainLayout />
        </AuthGuard>
    ),
    children: [
        {
            path: '/user/crear-orden-produccion',
            element: <OrdenProduccionFormView key="crear-orden-produccion" />
        },
        {
            path: '/user/editar-orden-produccion/:id',
            element: <OrdenProduccionFormView key="editar-orden-produccion" />
        },
        {
            path: '/user/lista-ordenes-produccion',
            element: <ListaOrdenesProduccionView />
        },
        {
            path: '/user/recetas-produccion',
            element: <RecetasProduccionView />
        }
    ]
};

export default ProduccionRoutes;
